module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1600@2x-d7c86d51235ca48daf0b62cf91a5e2ff.jpg";